/* Shared helpers used by both HomePage.jsx (desktop book view + kala wheel)
   and MobileFullPanchangam.jsx (mobile scrollable view), so both stay in
   sync from one source instead of importing across page/component files. */

export function getSpecialKalas(data) {
  if (!data || !data.kalas) return [];
  return [
    { id: "brahma_muhurta", name: { en: "Brahma Muhurta", te: "బ్రహ్మ ముహూర్తం", hi: "ब्रह्म मुहूर्त", ta: "பிரம்ம முகூர்த்தம்", kn: "ಬ್ರಹ್ಮ ಮುಹೂರ್ತ", ml: "ബ്രഹ്മ മുഹൂർത്തം" }, time: data.kalas.brahma_muhurta || "---" },
    { id: "durmuhurta", name: { en: "Durmuhurta", te: "దుర్ముహూర్తం", hi: "दुर्मुहूर्त", ta: "துர்முகூர்த்தம்", kn: "ದುರ್ಮುಹೂರ್ತ", ml: "ദുർമുഹൂർത്തം" }, time: data.kalas.durmuhurta || "---" },
    { id: "abhijit_muhurta", name: { en: "Abhijit Lagnam", te: "అభిజిత్ లగ్నం", hi: "अभिजित लग्न", ta: "அபிஜித் லக்னம்", kn: "ಅಭಿಜಿತ್ ಲಗ್ನ", ml: "അഭിജിത് ലഗ്നം" }, time: data.kalas.abhijit_muhurta || "---" },
    { id: "yamaganda", name: { en: "Yamaganda", te: "యమగండం", hi: "यमगण्ड", ta: "யமகண்டம்", kn: "ಯಮಗಂಡ", ml: "യമഗണ്ഡം" }, time: data.kalas.yamaganda || "---" },
    { id: "gulika", name: { en: "Gulika Kalam", te: "గుళిక కాలం", hi: "गुलिक काल", ta: "குளிக காலம்", kn: "ಗುಳಿಕ ಕಾಲ", ml: "ഗുളികകാലം" }, time: data.kalas.gulika || "---" },
    { id: "amrita_kala", name: { en: "Amrita Kalam", te: "అమృత కాలం", hi: "अमृत काल", ta: "அமிர்த காலம்", kn: "ಅಮೃತ ಕಾಲ", ml: "അമൃതകാലം" }, time: data.kalas.amrita_kala || "---" },
    { id: "rahukalam", name: { en: "Rahu Kalam", te: "రాహు కాలం", hi: "राहु काल", ta: "ராகு காலம்", kn: "ರಾಹು ಕಾಲ", ml: "രാഹുകാலം" }, time: data.kalas.rahukalam || "---" },
    { id: "varjyam", name: { en: "Varjyam", te: "వర్జ్యం", hi: "वर्ज्यम्", ta: "வர்ஜ்யம்", kn: "ವರ್ಜ್ಯ", ml: "വർജ്യം" }, time: data.kalas.varjyam || "---" },
  ];
}

// dayOffset places the time relative to today (-1 = a time read from
// yesterday's panchangam).
export function parseKalaTimeSafe(timeStr, dayOffset = 0) {
  if (!timeStr || timeStr === "---" || timeStr === "—") return null;
  const parts = timeStr.trim().split(" ");
  if (parts.length < 2) return null;
  let [time, modifier] = parts;
  let [hours, minutes] = time.split(":");
  hours = parseInt(hours, 10);
  if (hours === 12) hours = 0;
  if (modifier.toUpperCase() === "PM") hours += 12;
  const d = new Date();
  d.setHours(hours, parseInt(minutes, 10), 0, 0);
  // A trailing "(+1)" (sent by the backend for kala times past midnight)
  // means the next calendar day.
  d.setDate(d.getDate() + dayOffset + (parts.includes("(+1)") ? 1 : 0));
  return d;
}

export function checkTimeInRange(now, startStr, endStr, dayOffset = 0) {
  let start = parseKalaTimeSafe(startStr, dayOffset);
  let end = parseKalaTimeSafe(endStr, dayOffset);
  if (!start || !end) return false;
  // Day-marked times are already on the right day; only unmarked ranges
  // that wrap past midnight need the guess below.
  const marked = String(startStr).includes("(+1)") || String(endStr).includes("(+1)");
  if (end < start && !marked) {
    if (now < end) start.setDate(start.getDate() - 1);
    else end.setDate(end.getDate() + 1);
  }
  return now >= start && now < end;
}
